import React from "react";
import styled from "styled-components";
import {withStyles} from "@mui/styles";
import { Switch } from "@mui/material";
import { makeStyles } from "@mui/styles";


export const Main = styled("div")`
  font-family: 'Source Sans Pro', sans-serif;
  display: flex;
  float: left;
`;
export const SelectDateMain = styled("div")`
  font-family: "Source Sans Pro", sans-serif;
  display: flex;
  float: right;
  flex-direction: row;
  position: relative;
  left: -28px;
`;

export const DropDownContainer = styled("div")`
  margin-left: auto;
  margin-right: 0.9rem;
  cursor: pointer;
`;
export const DropDownHeader = styled("div")`
  margin-bottom: 0.5em;
  margin-top: 0.8em;
  padding: 0.6em;
  box-shadow: 0 1px 4px 0 grey;
  font-weight: normal;
  font-size: 17px;
  color: #605f70;
  background: #ffffff;
  border-radius: 0.2em;
  white-space: nowrap;
  display: -webkit-box;
  font-family: 'Source Sans Pro', sans-serif;
`;
export const DropDownListContainer = styled("div")`
  position: absolute;
  z-index: 5;
`;
export const DropDownList = styled("ul")`
  margin-bottom: 0.5em;
  margin-top: 0.5em;
  padding: 0.7em;
  box-shadow: 0 1px 4px 0 grey;
  background: #ffffff;
  border: 2px solid #e5e5e5;
  box-sizing: border-box;
  color: #605f70;
  font-size: 1.3rem;
  font-weight: 500;
  font-family: 'Source Sans Pro', sans-serif;

  &:first-child {
    border: 0.1rem solid grey;
  }

  border-radius: 0.5rem;
`;
export const IconContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 0.8rem;
`;
export const ListItem = styled("li")`
  display: block;
  padding-top: 0.5em;
  padding-left: 0.5rem;
  list-style: none;
  border-radius: 0.2rem;
  padding-bottom: 0.5em;

  &:hover {
    background-color: #50c878;
  }
`;

export const SubmitDateButton = styled("button")`{
  width: 40px;
  height: 40px;
  margin-top: 1.1rem;
  margin-left: 1.5em;
  padding-top: 3px;
  padding-right: 0px;
  padding-left: 0px;
  margin-bottom: 0em;
  border-radius: 21px;
  color: #ffffff;
  background: #91c73c;
  font-weight: 600;
  cursor: pointer;
  border: none;
  font-size: 10px;
  box-shadow: 0 14px 26px -12px rgb(145 194 65 / 42%), 0 4px 23px 0px rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(145 194 65 / 20%);
}
`;

export const HeaderDiv = styled("div")`{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 15px;
    margin-right: 15px;
}`;

export const EntityTitleMain = {
    marginTop: "18px",
    boxShadow: "grey 0px 1px 4px 0px",
    fontSize: "17px",
    backgroundColor: "#ffffff",
}

export const StyledDateInput = makeStyles((theme) => ({

    'MuiFilledInput-underline:after': {
        borderBottom: '2px solid #91c73c'
    }

}));
export const StyledSwitch = withStyles((theme) => ({
    root: {
        width: 46,
        height: 18,
        padding: 0,
        display: "flex",
        overflow: 'inherit'
    },
    switchBase: {
        padding: 2.5,
        color: "#FFFFFF",
        position: 'absolute',
        width: 20,
        height: 18,
        left: 2,
        top: -3,
        "&$checked": {
            transform: "translateX(22px)",
            color: "#605f70",
            "& + $track": {
                opacity: 1,
                backgroundColor: "#91c241",
            },
        },
    },
    thumb: {
        width: 16,
        height: 16,
        border: `1px solid `,
        marginTop: 0,
        top: 1,
        left: 3,
        position: 'relative',
    },
    track: {
        backgroundColor: '#605f70',
        opacity: 1,

        boxShadow: ' 0 1px 4px 0 grey',
    },
    checked: {},
}))(Switch);
export const FormControlLabelStyle = theme => ({
    labelStyle: {
        fontSize: '0.8rem',
        color: '#605f70',
    },

});
export const ControlLabelStyle = theme => ({
    labelStyle: {
        fontSize: '14px',
        color: '#333333',
    },

});

export const HeaderStyle = {
    width: '100%',
    height: '50px',
    display: 'flex',
    flexWrap: 'wrap',
    boxSizing: 'border-box',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignContent: 'center',
    marginLeft: "15px",
    marginRight: "15px",
}

export const SubmitDateButtonStyle = {
    width: '33px',
    height: '33px',
    marginTop: '1.2rem',
    marginLeft: '1.5em',
    paddingTop: '3px',
    paddingRight: '0px',
    paddingLeft: '0px',
    marginBottom: '0em',
    borderRadius: '21px',
    color: '#ffffff',
    background: '#91c73c',
    fontWeight: '600',
    cursor: 'pointer',
    border: 'none',
    fontSize: '10px',
    boxShadow: '0 14px 26px -12px rgb(145 194 65 / 42%), 0 4px 23px 0px rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(145 194 65 / 20%)'
  }


export const FormControlStyle = {
    marginLeft: "0.5em",
    flexDirection: "column",
    left: '6px',
    position: 'relative',
    top: '27px',
}

export const DropDownStyle = {
    color: '#605f70',
    background: '#ffffff',
    border: 'none',
    fontSize: ' 17px',
    marginBottom: '0.5em',
    marginTop: '0.8em',
    marginRight: '1em',
    padding: '0.4em',
    boxShadow: ' 0 1px 4px 0 grey',
    fontWeight: 'normal',
    borderRadius: '0.2em',
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    fontFamily: '"Source Sans Pro",sans-serif',
};
export const DropDownListStyle = {
    marginBottom: '0.5em',
    marginTop: '0.5em',
    padding: '0.5em',
    boxShadow: '0 1px 4px 0 grey',
    background: '#ffffff',
    boxSizing: 'border-box',
    color: '#605f70',
    fontSize: '1.2rem',
    fontFamily: '"Source Sans Pro",sans-serif',
    paddingLeft: '0',
};
export const DropDownListItemStyle = {
    margin: '0.2em',
    cursor: 'pointer',
    fontSize: '17px',
    '&::hover': {
        backgroundColor: '#50c878'
    }
};
export const DropDownIconStyle = {
    margin: '2px',
};

export const DateDropdownStyle = {
    root: {
        marginBottom: '0.5em',
        marginTop: '0.8em',
        marginRight: '1em',
        cursor: 'pointer',
        boxShadow: '0 1px 4px 0 grey',
        fontWeight: 'normal',
        fontSize: '17px',
        color: '#575757',
        background: 'rgb(255 255 255 / 90%)',
        border: 'none',
        borderRadius: '0.4rem',
        whiteSpace: 'nowrap',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'center',
        padding: '0.4em',
        paddingLeft: '1.5rem',
        paddingRight: '1.5rem',
        fontFamily: '"Source Sans Pro",sans-serif',
    }

};
export const DateDropDownListStyle =
{
    marginBottom: '0.5em',
    marginTop: '0.5em',
    marginRight: '0.5em',
    padding: '0.5em',
    background: '#ffffff',
    border: '2px solid #e5e5e5',
    boxSizing: 'border-box',
    color: '#605f70',
    fontSize: '17px',
    fontFamily: '"Source Sans Pro",sans-serif',
    borderRadius: '0.5rem',
}
    ;
export const DateDropDownListItemStyle = {
    display: 'block',
    paddingTop: '0.5em',
    paddingLeft: '0.5rem',
    listStyle: 'none',
    paddingBottom: '0.5em',
    fontFamily: '"Source Sans Pro",sans-serif',
    cursor: 'pointer',
    fontSize: '17px',
    '&:hover': {
        backgroundColor: '#91c241'
    },
    '&:firstChild': {
        border: '0.1rem solid grey'
    },
};

export const ChooseDateStyle = {
    fontSize: '12px',
    backgroundColor: '#ffffff',
    border: 'none',
    borderRadius: "0.2em",
    cursor: "pointer",
    // borderRadius: '0.3em',
    "& .MuiInputBase-input": {
        fontSize: '16px',
        fontWeight: '600',
        fontFamily: '"Source Sans Pro",sans-serif',
    },
    // "::webkit-calendar-picker-indicator": {
    //     cursor: "pointer",
    // },
    "&&&:before": {
        borderBottom: "none"
    },
    "&&:after": {
        borderBottom: "none"
    }
}
export const InputChooseDateStyle = {
    fontSize: '15px',
    fontWeight: '600',
    fontFamily: '"Source Sans Pro",sans-serif',
    // "& .Mui-focused": {
    //     color: "#91c241",
    // },
}
export const InputDateStyle = {
    textField: {
        fontSize: '15px',
        fontWeight: '600',
        fontFamily: '"Source Sans Pro",sans-serif',
        // "& .MuiInputBase-input": {
        //     fontSize: '16px',
        //     fontWeight: '600',
        //     fontFamily: '"Source Sans Pro",sans-serif',
        // },
    }
};
export const TextBoxStyle = {
    position: 'relative',
    top: '40px',
    margin: ' 10px',
    fontWeight: '600'
}
export const CardContainerStyle = {
    background: 'transparent', boxShadow: 'none', marginTop: '0px'
}
export const CardBodyContainerStyle = {
    padding: '0px'
}
export const ChartContainerGrid = {
    display: 'flex',
    flexWrap: 'wrap',
    boxSizing: 'border-box',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'baseline',
}
export const CustomNoDataTitleStyle = {
    fontFamily: '"Source Sans Pro",sans-serif',
};
export const LoadingDivFull = styled.div`
  height: 50vh;
  width: 20vw;
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  padding-top: 30vh;
  position: relative;
  left: 40%;
`;

export const LoadingDiv = styled.div`
  height: 248px;
  margin-left: 45%;
  margin-top: 100px;
`;

export const cardHeaderStyle = {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'flex-start',
};